function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { DO_NOT_USE_platformMetrics } from '@sail/observability';
import toError from '@sail/observability/dist/helpers/toError/toError';
import { FormatError, ErrorCode as FormatErrorCode } from 'intl-messageformat';
import { ReactIntlError } from 'react-intl';
import { IntlInvalidConfigError, IntlMessageFormatError, IntlMessageFormatInvalidValueError, IntlMessageFormatMissingIntlAPIError, IntlMessageFormatMissingValueError, IntlMissingDataError, IntlMissingMessageError, IntlMissingTranslationError } from '../../../internal/errors';
const reportedErrors = new Set();
// This function should never throw otherwise it will just break react-intl
// formatting fallbacks when there is an error
export const handleReactIntlError = (reports, analytics, locale, maybeError)=>{
    const errorMessage = reactIntlErrorToSailIntlError(toError(maybeError));
    const message = errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.message;
    trackMissingTranslations(errorMessage);
    if (message && !reportedErrors.has(message)) {
        reportedErrors.add(message);
        if (errorMessage instanceof IntlMissingTranslationError) {
            var _errorMessage_descriptor;
            const messageKey = ((_errorMessage_descriptor = errorMessage.descriptor) === null || _errorMessage_descriptor === void 0 ? void 0 : _errorMessage_descriptor.id) || 'NO_MESSAGE_KEY';
            analytics.track('i18n_translation_format_message_miss', {
                messageKey,
                locale
            });
        } else if (errorMessage instanceof IntlMessageFormatError) {
            reports.warning(errorMessage);
        } else {
            reports.error(errorMessage);
        }
    }
};
// New class that extends FormatError to include a MessageDescriptor
class EnhancedFormatError extends FormatError {
    constructor(msg, code, originalMessage, descriptor){
        super(msg, code, originalMessage);
        _define_property(this, "descriptor", void 0);
        this.descriptor = descriptor;
    }
}
// New class that extends ReactIntlError to include a MessageDescriptor
class EnhancedReactIntlError extends ReactIntlError {
    constructor(code, message, descriptor, exception){
        super(code, message, exception);
        _define_property(this, "descriptor", void 0);
        this.descriptor = descriptor;
    }
}
function isReactIntlErrorCode(error) {
    return 'code' in error;
}
function isReactIntlMessageDescriptor(error) {
    return 'descriptor' in error;
}
export function reactIntlErrorToSailIntlError(error) {
    if (isReactIntlErrorCode(error)) {
        switch(error.code){
            case 'MISSING_TRANSLATION':
                return new IntlMissingTranslationError(error, isReactIntlMessageDescriptor(error) ? error.descriptor : undefined);
            case 'FORMAT_ERROR':
                return new IntlMessageFormatError(error);
            case 'MISSING_DATA':
                return new IntlMissingDataError(error);
            case 'INVALID_CONFIG':
                return new IntlInvalidConfigError(error);
            case FormatErrorCode.MISSING_VALUE:
                return new IntlMessageFormatMissingValueError(error);
            case FormatErrorCode.INVALID_VALUE:
                return new IntlMessageFormatInvalidValueError(error);
            case FormatErrorCode.MISSING_INTL_API:
                return new IntlMessageFormatMissingIntlAPIError(error);
            default:
                break;
        }
    }
    if (error.message === '[React Intl] An `id` must be provided to format a message.') {
        return new IntlMissingMessageError();
    }
    return error;
}
function trackMissingTranslations(errorMessage) {
    const message = errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.message;
    if (message && errorMessage instanceof IntlMissingTranslationError) {
        var _errorMessage_descriptor_defaultMessage, _errorMessage_descriptor;
        DO_NOT_USE_platformMetrics.trackTranslationCount('miss');
        var _errorMessage_descriptor_defaultMessage_length;
        DO_NOT_USE_platformMetrics.translationCountForMessageLength('miss', (_errorMessage_descriptor_defaultMessage_length = (_errorMessage_descriptor = errorMessage.descriptor) === null || _errorMessage_descriptor === void 0 ? void 0 : (_errorMessage_descriptor_defaultMessage = _errorMessage_descriptor.defaultMessage) === null || _errorMessage_descriptor_defaultMessage === void 0 ? void 0 : _errorMessage_descriptor_defaultMessage.length) !== null && _errorMessage_descriptor_defaultMessage_length !== void 0 ? _errorMessage_descriptor_defaultMessage_length : 0);
    }
}

//# sourceMappingURL=handleReactIntlError.js.map